<template>
  <div
    class="lpu-services-price"
    :class="isMobile ? 'lpu-services-price_mobile' : 'lpu-services-price_full'"
  >
    <div
      class="d-flex justify-space-between align-center"
    >
      <div
        class="text-subtitle-1 text-right"
        :class="isClub ? 'error--text' : 'text--text'"
        :data-qa="dataQA.servicePriceFull"
      >
        {{ formattedPrice }}
      </div>
      <span
        v-show="!hasSchedule && isBtn && isClub"
        v-ripple
        class="b-lpu-services__price b-button b-button_coral-radial-gradient lpu-services-price__button ml-6"
        :data-qa="dataQA.servicePriceFullButton"
        @click="emitClickBtn"
      >
        <span class="ui-icon-calendar-date-and-clock bg-gray-0--text mr-2" />
        <span class="text-subtitle-1 bg-gray-0--text">
          Запись онлайн
        </span>
      </span>
      <v-btn
        v-show="!hasSchedule && isBtn && !isClub"
        depressed
        color="primary"
        class="b-lpu-services__price lpu-services-price__button ml-6"
        :data-qa="dataQA.servicePriceFullButton"
        @click="emitClickBtn"
      >
        <span class="ui-icon-calendar-date-and-clock bg-gray-0--text mr-2" />
        <span class="text-subtitle-1 bg-gray-0--text">
          Запись онлайн
        </span>
      </v-btn>
      <div
        v-show="hasSchedule && isBtn"
        class="b-lpu-services__toggle-calendar-wrap ml-6"
      >
        <v-btn
          depressed
          width="56"
          height="40"
          min-width="56"
          color="bg-gray-40"
          class="b-lpu-services__toggle-calendar"
          :data-qa="dataQA.toggleCalendar"
        >
          <div class="w-100 h-100 d-flex align-center justify-center">
            <span class="b-lpu-services__toggle-calendar-icon ui-icon-arrow-up icon-secondary--text" />
          </div>
        </v-btn>
      </div>
    </div>
    <div
      v-show="!isBtn"
      class="lpu-services-price__button ml-6"
    />
  </div>
</template>

<script>
import getFormattedPrice from 'www/utils/get/getFormattedPrice'
import { DATA_QA } from 'www/vue_components/common/LpuServices/constants'

export default {
  name: 'LpuServicesPrice',
  props: {
    price: {
      type: [Number, String],
      required: true,
    },
    isBtn: {
      type: Boolean,
      default: false,
    },
    isClub: {
      type: Boolean,
      default: false,
    },
    synonymId: {
      type: Number,
      required: true,
    },
    hasSchedule: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dataQA: DATA_QA,
  }),
  computed: {
    isMobile: () => window.MOBILE_VERSION,
    formattedPrice() {
      return getFormattedPrice(this.price)
    },
  },
  methods: {
    emitClickBtn(event) {
      this.$emit('lpu-services-price:click-btn', event)
    },
  },
}
</script>

<style scoped lang="scss">
.lpu-services-price {
  $block: &;

  min-width: 350px;

  &_full {
    $btn-width: 270px;

    #{$block}__button {
      flex: 0 0 $btn-width;
      width: $btn-width;
    }
  }

  &_mobile {
    #{$block}__button {
      padding: 0 16px;
    }
  }
}
</style>
